import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    dialogPaper: {
      borderRadius: '25px !important',
      padding: '20px',
      width: '400px',
      maxWidth: '100%',
    },
    title: {
      color: '#0047BA',
      fontSize: '24px',
      fontWeight: 'bold',
      fontFamily: 'Noto Sans',
    },
    button: {
      alignSelf: 'center',
      borderRadius: '17px',
      backgroundColor: '#0047BA',
      color: '#FFF',
      maxHeight: '50px',
      maxWidth: '120px',
    },
  })
);

export default useStyles;
